import { Injectable, EventEmitter, Output } from '@angular/core';

@Injectable()
export class ResponseChangedService{
    @Output() changedResponseEvent = new EventEmitter<number>();

    changedResponse(questionId: number) {
      this.changedResponseEvent.emit(questionId);
    }
}
